// extracted by mini-css-extract-plugin
export var centerText = "_cb-8";
export var container = "_cb-0";
export var doughnutContainer = "_cb-7";
export var legend = "_cb-a";
export var legendItemColorDisplay = "_cb-b";
export var legendItemLabel = "_cb-d";
export var legendItemValue = "_cb-c";
export var lg = "_cb-5";
export var maxWidth = "_cb-9";
export var md = "_cb-4";
export var responsive = "_cb-6";
export var sm = "_cb-3";
export var xs = "_cb-2";
export var xxs = "_cb-1";